export enum IndicatorType {
	Validated = 1,
	PendingEligible = 2,
	PendingIneligible = 3,
}
